import { Component } from '@verndale/core';

class SCurve extends Component {
  setupDefaults() {
    this.dom = {
      items: this.el.querySelectorAll('.s-curve__item')
    };

    this.setupDesign();
  }

  setupDesign() {
    this.dom.items.forEach((item, index) => {
      const headline = item.querySelector('.alternating-headline');
      const card = item.querySelector('.s-curve-card');

      if (index % 2) {
        headline?.classList.add('alternating-headline--right');
        card?.classList.add('s-curve-card--right');
        const unneededPictures = card.querySelectorAll('.s-curve-card__media--left');
        unneededPictures.forEach(picture => picture.remove());
      }
      else {
        headline?.classList.add('alternating-headline--left');
        card?.classList.add('s-curve-card--left');
        const unneededPictures = card.querySelectorAll('.s-curve-card__media--right');
        unneededPictures.forEach(picture => picture.remove());
      }
    });
  }
}

export default SCurve;
